import FabricCanvas from './FabricCanvas';

export default FabricCanvas;
